import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getNotiService = async (product, site_uuid) => {
  const { data } = await supabase
    .from(`site_${product}_noti`)
    .select()
    .eq("site_uuid", site_uuid)
    .order("id");
  return await data[0];
};

export const setNotiService = async (product, payload) => {
  const { data } = await supabase.from(`site_${product}_noti`).insert(payload);
  return await data;
};

export const updateNotiService = async (product, payload) => {
  const { data } = await supabase
    .from(`site_${product}_noti`)
    .update(payload)
    .eq("site_uuid", payload.site_uuid);
  return await data;
};

export const getNotiAccountService = async (account_uuid) => {
  const { data } = await supabase
    .from("account")
    .select()
    .eq("account_uuid", account_uuid)
    .order("id");
  return await data[0];
};

export const setNotiAccountService = async (payload) => {
  const { data } = await supabase.from("account").insert(payload);
  return await data;
};

export const updateNotiAccountService = async (payload) => {
  const { data } = await supabase
    .from("account")
    .update(payload)
    .eq("account_uuid", payload.account_uuid);
  return await data;
};
